import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authMe, login as apiLogin, logout as apiLogout } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = unauth, obj = authed
  const refresh = useCallback(() => authMe().then((u) => setUser(u)).catch(() => setUser(false)), []);
  useEffect(() => { refresh(); }, [refresh]);

  const signIn = async (email, password) => {
    const r = await apiLogin(email, password);
    setUser(r.user);
    return r.user;
  };
  const signOut = async () => { try { await apiLogout(); } catch (e) {} setUser(false); };

  return <AuthCtx.Provider value={{ user, signIn, signOut, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
